import React from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
	return (
		<header className="site-header">
			<div className="container row">
				<a href="#main" className="skip-link">Skip to content</a>
				<Link to="/" className="brand" aria-label="Appex Connect Hub">
					<svg width="28" height="28" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x="6" y="6" width="52" height="52" rx="12" fill="#1f4f8b"/>
						<path d="M20 40l6-16h4l6 16h-4l-1.4-4h-5.2L24 40h-4zm8-12l-1.7 5h3.4L28 28z" fill="white"/>
					</svg>
					<span>Appex Connect Hub</span>
				</Link>
				<nav className="nav" aria-label="Primary">
					<NavLink to="/services">Services</NavLink>
					<NavLink to="/compliance">Compliance</NavLink>
					<NavLink to="/industries">Industries</NavLink>
					<NavLink to="/case-studies">Case Studies</NavLink>
					<NavLink to="/faq">FAQ</NavLink>
					<NavLink to="/about">About</NavLink>
					<NavLink to="/contact">Contact</NavLink>
					<NavLink to="/sms-policy">SMS Policy</NavLink>
				</nav>
			</div>
		</header>
	);
}

export default Header;


